import {
  FEATURE_PAGE_PATH,
  TRANSLATION_CATEGORY_PARAM,
  type TranslationView,
} from "@/v2-backoffice-client/translation/translation.constants"

// The board is URL-addressable, so every entry that reaches one of its views
// is a plain link rather than a click handler: /features/<view> for the
// pinned views (bare /features being the default triage queue), and
// /features/catalog?category=<key> for one category slice of the catalog.
export function getTranslationViewHref(view: TranslationView): string {
  return view === "incomplete"
    ? FEATURE_PAGE_PATH
    : `${FEATURE_PAGE_PATH}/${view}`
}

export function getTranslationCategoryHref(categoryKey: string): string {
  const key = encodeURIComponent(categoryKey)
  return `${FEATURE_PAGE_PATH}/catalog?${TRANSLATION_CATEGORY_PARAM}=${key}`
}

// Category = the feature code's root prefix (everything before the leaf
// segment): "UI_MapLayer_Foo" -> "UI_MapLayer", "Company_Ownership_Bar" ->
// "Company_Ownership". Used for grouping / hierarchy in the table.
//
// ponytail: a plain split heuristic. Follow the ADR-0025 UI_<Feature>_<Surface>
// segmentation once the naming standardization lands.
export function deriveCategory(code: string): string {
  const parts = code.split("_")
  return parts.length > 1 ? parts.slice(0, -1).join("_") : code
}
